export enum TasResponseTag {
  'TAS.ProgramApproval.APPROVE',
  'TAS.ProgramApproval.REJECT',
  'TAS.ProgramApproval.REVISE',
  'TAS.CourseApproval.APPROVE',
  'TAS.CourseApproval.REJECT',
  'TAS.CourseApproval.REVISE',
  'TAS.EvidenceApproval.APPROVE',
  'TAS.EvidenceApproval.REJECT',
  'TAS.EvidenceApproval.REVISE',
  'TAS.WithdrawComplete.APPROVE',
  'TAS.WithdrawComplete.REJECT',
  'TAS.WithdrawComplete.REVISE',
}

export const APPROVAL_RESPONSE_TYPES = new Map<keyof typeof TasResponseTag, string>([
  ['TAS.ProgramApproval.APPROVE', 'Approve Program'],
  ['TAS.ProgramApproval.REJECT', 'Reject Program'],
  ['TAS.ProgramApproval.REVISE', 'Revise Program'],
  ['TAS.CourseApproval.APPROVE', 'Approve Course'],
  ['TAS.CourseApproval.REJECT', 'Reject Course'],
  ['TAS.CourseApproval.REVISE', 'Revise Course'],
  ['TAS.EvidenceApproval.APPROVE', 'Approve Evidence'],
  ['TAS.EvidenceApproval.REJECT', 'Reject Evidence'],
  ['TAS.EvidenceApproval.REVISE', 'Revise Evidence'],
  ['TAS.WithdrawComplete.APPROVE', 'Approve Withdrawal'],
  ['TAS.WithdrawComplete.REJECT', 'Reject Withdrawal'],
  ['TAS.WithdrawComplete.REVISE', 'Revise Withdrawal'],
]);
